import { module } from 'modujs'
import { CUSTOM_EVENT, ENV, FONT } from '../config'
import { whenReady } from '../utils/fonts'
import { gsap, SplitText } from '../gsap'

export default class extends module {

    constructor(m) {
        super(m)

        this.$el = this.el
        this.$text = this.$('text')[0]
    }

    init() {

        whenReady(FONT.EAGER).then(() => {
            // Split lines
            this.initSplits()

            // Resize event
            window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.onResize = () => this.resize())
        })
    }

    initSplits() {

        // Split text
        this.split = new SplitText(this.$text, {
            type: 'words, chars',
        })

        this.split.chars.forEach(char => {
            gsap.set(char, { willChange: 'opacity' })
        })

        this.tl = gsap.timeline({
            paused: true,
            // defaults: {
            //     ease: 'none',
            // },
        })

        this.tl.from(this.split.chars, {
            opacity: 0.3,
            stagger: 0.02,
        })
    }

    revertSplits() {
        this.split?.revert()

        this.tl.kill()
    }

    resize() {
        this.revertSplits()
        this.initSplits()
    }

    onScrollProgress(progress) {
        this.tl?.progress?.(progress || 0)
    }

    destroy() {
        window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.onResize)
    }
}
